/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type { StackDeployment } from '@modules/ui-types'
import type { WithRouterProps } from '@modules/routing/withRouter'
import withRouter from '@modules/routing/withRouter'

import { getStackDeployment } from '@/reducers/stackDeployments'

import LogsMetrics from './LogsMetrics'

import type { ReduxState } from '@/types/redux'

type StateProps = {
  deployment: StackDeployment | undefined
}

type ConsumerProps = WithRouterProps<{ deploymentId: string }>

const mapStateToProps = (
  state: ReduxState,
  {
    router: {
      params: { deploymentId },
    },
  }: ConsumerProps,
): StateProps => ({
  deployment: getStackDeployment(state, deploymentId),
})

export default withRouter(
  connect<StateProps, unknown, ConsumerProps>(mapStateToProps, {})(LogsMetrics),
)
